<template>

<section
    class="section-container"
    id="files"
    :class="{'drag_valid': dropzone_active}"
    @click="remove_file_highlight()">

<div 
    v-if="!disable_upload" 
    id="dropzone" 
    @dragenter.prevent.stop
    @dragover.prevent.stop
    @dragleave.prevent.stop="dropzone_active = false"
    @drop.prevent="something_dropped">
    Drop your file to upload
</div>

<!-- No buckets -->
<div v-if="user && !user.is_client_space_client && buckets && buckets.length == 0" class="container mt-3" style="top: 15px">
    <div class="row">
        <div class="col-2 d-none d-md-table-cell"></div>
        <div class="col-12 col-lg-8">
            <div class="jumbotron text-white" :class="{'bg-gradient-info': user.is_admin, 'bg-gradient-warning': !user.is_admin}">
                <div class="container">
                    <section v-if="user.is_admin">
                        <h1>Hello and welcome to SkyFlok!</h1>
                        <h4 class="mt-3">To get started, first you need to set where your data will be stored.</h4>
                        <h4 class="mt-3">Please go to <u><router-link to="/team-setup" class="text-white">Team Setup</router-link></u> and set up your account now!</h4>
                    </section>
                    <section v-else>
                        <h4>This Team account is not ready to upload files, please ask one of the Team Administrators to complete the initial setup!</h4>
                    </section>
                </div>
            </div>
        </div>
    </div>
</div>

<div v-else id="file_list" class="container-fluid">

    <div v-if="show_clouds_ready_box" class="row">
        <div class="col-2"></div>
        <div class="col-12 col-lg-8">
            <div class="cardbox text-white bg-gradient-success b0">
                <div class="cardbox-body text-center text-bold text-12">
                    Congratulations, your SkyFlok account is fully set up!
                    <br/>Upload some files by clicking on the large blue button below,
                    <br/>or drag and drop them into the window!
                </div>
            </div>
        </div>
    </div>

    <!-- Admin Folder description -->
    <div class="row" v-if="false && is_admin_folder">
        <div class="col-2"></div>
        <div class="col-12 col-lg-8">
            <div class="cardbox text-white bg-gradient-warning b0">
                <div class="cardbox-body text-center text-bold text-12">
                    This is a safe folder that is only visible and accessible for Team Administrators.
                    <br/>
                    It's an ideal place for things you don't want to share with the whole team, like passwords, invoices, contracts, Non-Disclosure Agreements and similar files.
                </div>
            </div>
        </div>
    </div>


    <!-- Breadcrumbs -->
    <div class="row" v-if="nav_stack.length > 1">
        <div class="col-12 breadcrumb d-flex align-items-center gap-1">
            <!-- Clickable buttons for previous folders (including root) -->
            <div class="nowrap" v-for="(folder, index) in nav_stack.slice(0, nav_stack.length - 1)" :key="index" @dragover.prevent="folder.dragover=true" @dragleave.prevent="folder.dragover=false" @drop.prevent="drop($event, folder)" >
                <button class="btn btn-flat btn-info btn-sm" type="button"  :class="{'bg-success': folder.dragover}" @click="change_folder_to(folder)">
                    <i v-if="folder.id == -1" class="icon ion-home"></i>
                    <span v-else>{{folder.name}} <i v-if="folder.shares_num > 0" class="ion-link ml-1 icon-lg" v-popover="'This folder is shared'"/></span>
                </button>
                <i class="ion-chevron-right v-middle" v-if="index < nav_stack.length-1"/>
            </div>
            <!-- Last folder that we are in (not a button) -->
            <div class="d-inline-block nowrap btn btn-flat btn-sm btn-secondary c-default text-bold" :disabled="true">
                {{ nav_stack[nav_stack.length-1].name }} <i v-if="nav_stack[nav_stack.length-1].shares_num > 0" class="ion-link ml-1 icon-lg" v-popover="'This folder is shared'"/>
            </div>
        </div>
    </div>
    <!-- Folders -->
    <div class="row" id="folders">

        <div class="folder-box col-12 col-sm-6 col-md-6 col-lg-4 col-xl-3"
            v-for="folder in folders" :key="folder.id"
            :class="{'dragover': folder.dragover}"
            :id="`skyflok-folder-${folder.id}`"
            @click="folder.rename ? false : change_folder_to(folder)">
            <!-- only navigate into folder if it's not being renamed -->

            <!--
                :draggable="!disable_namespace_ops"
                @dragstart="drag($event, folder)"
                @drop.prevent="drop($event, folder)"
                @dragend="dragend($event, folder)"
                @dragover.prevent="folder.dragover=true"
                @dragleave.prevent="folder.dragover=false"
                -->
            <div
                :class="['cardbox', get_folderbox_class(folder)]"
                style="border-left: 4px solid;">
                <div class="cardbox-body" :title="folder.name">
                    <div v-if="!folder.rename" class="d-flex justify-content-start align-items-center">

                        <i class="ion-folder mr-2"></i>
                        <span class="mb-0 foldername">{{ folder.name }} <i v-if="folder.shares_num > 0" class="ion-link ml-2 icon-lg" v-popover="'This folder is shared'"/></span>
                        

                        <div v-if="!disable_share || !disable_namespace_ops" class="ml-auto" @click.prevent.stop="folderbox_dropdown('folder_'+folder.id+'_dropdown')" title="Show folder options">
                            <div class="dropdown btn-group">
                                <button class="btn btn-sm btn-secondary btn-flat mb-0 mt-0 folder-overflow-btn" :id="'folder_'+folder.id+'_dropdown'" type="button" data-toggle="dropdown" aria-expanded="false" ><i class="ion-more text-gray-light"></i>
                                </button>
                                <div class="dropdown-menu dropdown-menu-right mt-2" role="menu">
                                    <a v-if="!disable_share && folder_shares_enabled" class="dropdown-item" href="#" @click.prevent="open_share_form(folder)"><i class="ion-share icon-lg mr-3"></i>Share Folder</a>
                                    <a v-if="!disable_namespace_ops" class="dropdown-item" href="#" @click.prevent="rename_file(folder)"><i class="ion-edit icon-lg mr-3"></i>Rename</a>
                                    <a v-if="!disable_namespace_ops"  class="dropdown-item" href="#" @click.prevent="copy_move_file('move_folder', folder)"><i class="ion-forward icon-lg mr-3"></i>Move</a>
                                    <a class="dropdown-item" href="#" @click.prevent="open_file_info_modal(folder)"><i class="ion-information-circled icon-lg mr-3"></i>Folder info</a>
                                    <div v-if="!disable_namespace_ops" class="dropdown-divider"></div>
                                    <a v-if="!disable_namespace_ops" class="dropdown-item text-danger" href="#" @click.prevent="delete_file(folder)">
                                        <i class="ion-trash-a icon-lg mr-3"></i>Delete
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-else class="nowrap">
                        <!-- Folder rename -->
                        <form @submit.prevent="rename_submit(folder)">
                        <div class="d-flex align-items-center gap-1">
                            <input :id="`file-rename-${folder.id}`" class="form-control form-control-sm text-inherit" type="text" v-model="folder.rename.name" :disabled="folder.rename.loading"/>
                            <template v-if="!folder.rename.loading">
                                <button class="btn btn-sm btn-success btn-gradient" type="submit" ><i class="ion-checkmark-round"></i></button>
                                <button class="btn btn-sm btn-secondary btn-gradient" type="button" @click.prevent.stop="folder.rename = false"><i class="ion-close-round"></i></button>
                            </template>
                            <i v-else class="ion-load-c spin text-initial"></i>
                        </div>
                        </form>
                        <div v-if="folder.rename.error" class="text-sm text-danger">{{ folder.rename.error }}</div>
                    </div>
                </div>
            </div>
        </div>

        <div v-if="!disable_namespace_ops" class="folder-box add_folder col-12 col-sm-6 col-md-6 col-lg-4 col-xl-3">
            <div class="cardbox text-white bg-gradient-secondary">
                <div class="cardbox-body">
                <template v-if="new_folder_mode">
                    <form @submit.prevent="create_folder(new_folder_name)">
                    <div class="input-group" style="padding: 4px 0px">
                        <input class="form-control form-control-sm" type="text" v-model="new_folder_name" id="new_folder_name_input" placeholder="Folder Name"/>
                        <button class="btn btn-sm btn-success btn-gradient ml-1" type="submit" :disabled="new_folder_loading"><i :class="{'ion-checkmark-round': !new_folder_loading, 'ion-load-c spin': new_folder_loading}"></i></button>
                        <button class="btn btn-sm btn-warning btn-gradient ml-1" type="button" @click="new_folder_form(false)"><i class="ion-close-round"></i></button>
                    </div>
                    </form>
                </template>
                <template v-else>
                    <div class="d-flex justify-content-start align-items-center nowrap gap-1" @click="new_folder_form(true)"><!-- height: 37px -->
                        <i class="ion-plus mr-2"></i>
                        <p class="mb-0">Create Folder</p>
                    </div>
                </template>
                </div>
            </div>
        </div>
    </div>

    <!-- Files -->
    <div class="row" id="files" >
        <div class="col-12" v-if="files.length > 0">

            <div class="cardbox">
                
                <!-- Top bar -->
                <div class="cardbox-heading d-flex justify-content-between align-items-end">

                    <div class="d-flex align-items-end gap-2">

                        <div v-if="!selected_files.length" class="text-muted text-sm">
                            <!--TODO count filtered files when filter(s) are active-->
                            <div>{{ files.length }} File{{ files.length == 1 ? '' : 's' }}</div>
                            <div v-if="folders.length">{{ folders.length }} Folder{{ folders.length == 1 ? '' : 's' }}</div>
                        </div>

                        <!-- Active filters -->
                        <div v-if="false" class="filters">
                            <span class="btn btn-oval bg-blue-500 mx-1 my-1" v-if="list_filters.types.length">Type: {{ list_filters.types | join(', ') }} <i class="ion-close-round ml-2" @click="list_filters.types = []"></i></span>
                        </div>
                        
                        <!--Batch file actions -->
                        <div class="batch-actions p-2" v-if="selected_files.length">
                            <div class="text-sm mb-1">
                                {{ selected_files.length }} File{{ selected_files.length == 1 ? '' : 's' }}
                                <a @click.prevent="multiselect_clear()" class="ml-2 ion-close-round color-brand" href="#" title="Clear selection"></a>
                            </div>
                            <div class="d-flex gap-2 align-items-center">
                                <template v-if="!disable_download">
                                    <a v-if="files_multidownload_in_progress" href="#" @click.prevent="download_all_cancel()">Cancel</a>
                                    <button v-else class="btn btn-success btn-gradient" @click="download_all_selected()">Download</button>
                                </template>
                                
                                <!-- Copy/move 
                                 TODO: copy_move_file() does not handle multiple files yet!
                                <button class="btn btn-info btn-gradient" :disabled="files_multidownload_in_progress" @click="copy_move_file('move_files')">Move</button>
                                <button class="btn btn-secondary btn-gradient" :disabled="files_multidownload_in_progress" @click="copy_move_file('copy_files')">Copy</button>
                                -->
                                <button v-if="!disable_share" class="btn btn-secondary btn-gradient" :disabled="files_multidownload_in_progress" @click="open_share_form(selected_files)">Share</button>
                                <button v-if="!disable_namespace_ops" class="btn btn-danger btn-gradient" :disabled="files_multidownload_in_progress" @click="delete_file()">Delete</button>
                            </div>
                        </div>

                    </div>

                    <!-- Action buttons -->
                    <div class="action-buttons">
                        <!--Enable filter button when we have more filters-->
                        <button 
                            v-if="false"
                            class="btn btn-secondary btn-gradient mx-1 my-1 d-none d-xl-inline-block" 
                            data-toggle="modal" data-target="#filter-modal" 
                            ><i class="ion-funnel mr-1 icon-lg"></i> 
                            <!-- Overwrite this when merging multiple-clients-per-space, but move to the right  -->
                            Filters
                        </button>

                        <div class="btn-group dropdown" v-if="!disable_upload">
                            <button class="btn btn-brand btn-gradient" @click="file_upload_el.click()">
                                <i class="ion-arrow-up-a icon-lg mr-2"></i>
                                <span>Upload</span>
                            </button>
                            <template v-if="!is_mobile"><!-- Can't upload a folder from mobile OS -->
                                <button class="btn dropdown-toggle btn-brand" style="border-left: 1px solid #ebebeb;" type="button" data-toggle="dropdown" aria-expanded="false"><span class="caret"></span></button>
                                <div class="dropdown-menu" role="menu">
                                    <a class="dropdown-item" href="#" @click.prevent="folder_upload_el.click()">
                                        <i class="ion-folder icon-lg mr-3"></i>
                                        <span>Folder Upload</span>
                                    </a>
                                </div>
                            </template>
                        </div>
                    </div>
                </div>

                <div class="file-list">
                    <table class="table table-hover multiselectable" :class="{'has-selection': selected_files.length > 0}">
                        <thead>
                            <tr>
                                <th v-if="!multiselect_disabled" class="width-0" @click="select_all = !select_all">
                                    <input type="checkbox" class="multiselect-all-checkbox" v-model="select_all"  />
                                </th>
                                <th class="width-0" @click="multiselect_disabled ? false : select_all = !select_all" :style="{'padding-left': multiselect_disabled ? '' : '0px !important'}"></th><!-- Make the icon header also clickable as select/deselect all -->
                                <th class="text-left nowrap"><span class="sort_header" @click="sort_by('name')">Filename <i class="text-gray-light ml-1" v-if="list_sort.attr==='name'" :class="{'ion-arrow-up-c': list_sort.asc, 'ion-arrow-down-c': !list_sort.asc}"></i></span></th>
                                <th class="nowrap"><span class="sort_header" @click="sort_by('extension')">Type <i class="text-gray-light ml-1" v-if="list_sort.attr==='extension'" :class="{'ion-arrow-up-c': list_sort.asc, 'ion-arrow-down-c': !list_sort.asc}"></i></span></th>
                                <th class="d-none d-xl-table-cell nowrap"><span class="sort_header" @click="sort_by('size')">Size <i class="text-gray-light ml-1" v-if="list_sort.attr==='size'" :class="{'ion-arrow-up-c': list_sort.asc, 'ion-arrow-down-c': !list_sort.asc}"></i></span></th>
                                <th class="d-none d-md-table-cell nowrap"><span class="sort_header" @click="sort_by('last_modified')">Uploaded <i class="text-gray-light ml-1" v-if="list_sort.attr==='last_modified'" :class="{'ion-arrow-up-c': list_sort.asc, 'ion-arrow-down-c': !list_sort.asc}"></i></span></th>
                                <th v-if="!disable_share" class="d-none d-xl-table-cell nowrap"><span class="sort_header" @click="sort_by('shares_num')">Shares <i class="text-gray-light ml-1" v-if="list_sort.attr==='shares_num'" :class="{'ion-arrow-up-c': list_sort.asc, 'ion-arrow-down-c': !list_sort.asc}"></i></span></th>
                                <th class="d-none d-md-table-cell  width-0" v-if="!disable_download"></th>
                                <th class="width-0"></th>
                            </tr>
                        </thead>

                        <tbody v-for="(file, file_idx) in files" :key="file.id" :class="{ open: file.show_details }" :id="`skyflok-file-${file.id}`">
                            <!--
                            :draggable="!disable_namespace_ops"
                            @dragstart="drag($event, file)" 
                            @dragend="dragend($event, file)"
                            -->
                            <tr 
                                :id="'file-row-'+file.id" 
                                class="file-row" 
                                :class="{
                                    'text-gray-light': file.loading, 
                                    'highlighted': file.highlighted, 
                                    'selected': file.selected
                                }" 
                            >
                                
                                <td v-if="!multiselect_disabled" class="width-0"  @click="multiselect($event, file_idx)">
                                    <input type="checkbox" class="multiselect-checkbox" :checked="file.selected" @click.stop="multiselect($event, file_idx)"  />
                                </td>
                                <td :style="{'padding-left': multiselect_disabled ? '' : '0px !important'}"> 
                                    <img :src="file.extension | filetype_img_src" class="file-icon" />
                                </td>
                                <td class="text-left">
                                    <span v-if="!disable_download">
                                        <span v-if="!file.rename" class="break-word" :title="'Click to download ' + file.name">
                                            <a @click.prevent="download_file(file)" href="#" class="text-inherit">{{ file.display_name }}</a>
                                            <span v-if="file.loading" class="d-inline ml-2 text-sm">({{ Math.round(file.loading) }}%)</span>
                                            <a v-if="file.versions_num > 1" class="ml-2 badge badge-light" @click.prevent="file.show_details = 'versions'" href="#" v-popover="'Show version history'">v{{ file.versions_num }}</a>
                                        </span>
                                        <div v-else class="nowrap">
                                            <form @submit.prevent="rename_submit(file)" class="d-flex align-items-center gap-1"><!-- Use a form so Enter submits it  -->
                                                <input type="text" :id="`file-rename-${file.id}`" class="form-control form-control-sm" style="width: calc(100% - 60px)" v-model="file.rename.name" :disabled="file.rename.loading" />
                                                <template v-if="!file.rename.loading">
                                                <button class="btn btn-sm btn-success btn-gradient" type="submit"><i class="ion-checkmark-round"></i></button>
                                                <button class="btn btn-sm btn-secondary btn-gradient" type="button" @click="file.rename = false"><i class="ion-close-round"/></button>
                                                </template>
                                                <i v-else class="ion-load-c spin"></i>
                                            </form>
                                            <div v-if="file.rename.error" class="text-sm text-danger">{{ file.rename.error }}</div>
                                        </div>
                                    </span>
                                    <span v-else class="text-muted text-bold" :title="file.name" style="cursor: not-allowed">
                                        {{ file.display_name }}
                                    </span>
                                </td>
                                <td><span class="text-sm text-upper" :class="{'text-muted': !file.extension}">{{ file.extension || '-' }}</span></td>
                                <td class="d-none d-xl-table-cell">
                                    <div v-if="!file.size"><i class="ion-load-c spin text-muted"></i></div>
                                    <span v-else class="text-muted text-sm">{{ file.size | format_bytes }}</span>
                                </td>
                                <td class="d-none d-md-table-cell width-0">
                                    <div v-if="file.last_modified_by === undefined"><i class="ion-load-c spin text-muted"></i></div>
                                    <span v-else class="text-sm"><modified-box v-if="user && user.team" :user-id="file.last_modified_by" :team="user.team" :timestamp="file.last_modified" :external-actor="modifiedBoxExternal"></modified-box></span>
                                </td>
                                <td v-if="!disable_share" class="d-none d-xl-table-cell">
                                    <div v-if="file.shares_num === undefined"><i class="ion-load-c spin text-muted"></i></div>

                                    <a v-else-if="file.shares_num > 0" href="#" @click.prevent="file.show_details == 'shares' ? file.show_details = false : file.show_details = 'shares'" style="color:inherit" title="List shares of this file">
                                        <i class="ion-link icon-lg mr-2"/>{{ file.shares_num }}
                                    </a>
                                    <a v-else @click="open_share_form(file)" class="c-pointer text-muted" title="Share this file">
                                        <i class="ion-plus-round"/>
                                    </a>
                                </td>
                                <td class="d-none d-md-table-cell" v-if="!disable_download">
                                    <button 
                                        v-if="file.cancel" 
                                        @click="file.cancel()" 
                                        class="btn text-sm btn-danger btn-flat">
                                        CANCEL <i class="ion-close-round ml-1"></i>
                                    </button>
                                    <section v-else>
                                        <button
                                            v-if="file.viewer && file.id > 0"
                                            class="btn text-sm btn-flat"
                                            :class="[file.viewer.btn_class]"
                                            @click.prevent="open_file(file)"
                                            :title="'Open with ' + file.viewer.label">{{ file.viewer.verb }} <i class="icon-lg ml-2" :class="file.viewer.icon_class"></i></button>
                                        <button v-else class="btn btn-secondary btn-flat disabled" disabled :title="'Cannot preview ' + (file.extension ? file.extension.toUpperCase()  : 'these types of ') + ' files yet :('">-</button>
                                    </section>
                                </td>

                                <td>
                                    <div v-if="file.id > 0" class="dropdown btn-group">
                                        <button class="btn btn-secondary btn-flat" type="button" data-toggle="dropdown" aria-expanded="false" style="font-size: 1rem">
                                            <i class="ion-more icon-lg text-muted" style="vertical-align: initial"></i>
                                        </button>
                                        <div class="dropdown-menu dropdown-menu-right" role="menu">
                                            <a v-if="!disable_share" class="dropdown-item" href="#" @click.prevent="open_share_form(file)"><i class="ion-share icon-lg mr-3"></i>Share</a>
                                            <a v-if="!disable_download" class="dropdown-item" href="#" @click.prevent="download_file(file)"><i class="ion-arrow-down-a icon-lg mr-3"></i>Download</a>
                                            <a v-if="!disable_namespace_ops" class="dropdown-item" href="#" @click.prevent="rename_file(file)"><i class="ion-edit icon-lg mr-3"></i>Rename</a>
                                            <a v-if="!disable_namespace_ops" class="dropdown-item" href="#" @click.prevent="copy_move_file('move_file', file)"><i class="ion-forward icon-lg mr-3"></i>Move</a>
                                            <a v-if="!disable_namespace_ops" class="dropdown-item" href="#" @click.prevent="copy_move_file('copy_file', file)"><i class="ion-plus-circled icon-lg mr-3"></i>Copy</a>
                                            <a class="dropdown-item" href="#" @click.prevent="is_mobile ? open_file_info_modal(file) : file.show_details = 'info'"><i class="ion-information-circled icon-lg mr-3"></i>File info</a>
                                            <div v-if="!disable_namespace_ops" class="dropdown-divider"></div>
                                            <a v-if="!disable_namespace_ops" class="dropdown-item text-danger" href="#" @click.prevent="delete_file(file)">
                                                <i class="ion-trash-a icon-lg mr-3" />Delete
                                            </a>
                                        </div>
                                    </div>
                                </td>
                            </tr>

                            <tr class="file-loading" v-if="file.loading">
                                <td colspan="9">
                                    <div class="progress">
                                        <div class="progress-bar progress-bar-striped progress-bar-animated"
                                            role="progressbar" :aria-valuenow="file.loading" aria-valuemin="0" aria-valuemax="100" :style="{'width': Math.round(file.loading)+'%'}"></div>
                                    </div>
                                </td>
                            </tr>
                            <tr v-if="file.show_details">
                                <td colspan="99" class="file-details-cell">
                                    
                                    <file-info-versions-shares
                                        :user="user"
                                        :file="file"
                                        :view="file.show_details"
                                        :file_version_external_user="modifiedBoxExternal"
                                        :hide_shares="disable_share"
                                        :disable_download="disable_download"
                                    />
                                    
                                    <div class="text-center">
                                        <button
                                            class="btn btn-secondary btn-sm text-sm"
                                            @click="file.show_details = false"
                                            title="Close info panel">
                                            Close <i class="ion-close-round ml-1"></i>
                                        </button>
                                    </div>
                                    
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>

    <!-- 'Empty' box -->
    <section v-if="files && files.length == 0 && !loading_filelist">
        <div v-if="disable_upload" class="row">
            <div class="col-4"></div>
            <div class="col-12 col-lg-4">
                <hero-box :bg-class="'bg-gradient-secondary'" :icon="'ion-qr-scanner'" :text="'Empty directory'"></hero-box>
            </div>
        </div>

        <div v-else class="row">
            <div class="col-1"></div>
            <div class="col-12 col-lg-5 ">
                <hero-box :bg-class="'bg-gradient-primary'" :icon="'ion-ios-copy-outline'" text="Upload Files" :clicked="()=>{ file_upload_el.click() }"></hero-box>
            </div>
            <div class="col-12 col-lg-5">
                <hero-box :bg-class="'bg-gradient-info'" :icon="'ion-ios-folder-outline'" text="Upload Folder" :clicked="()=>{ folder_upload_el.click() }"></hero-box>
            </div>
        </div>

    </section>

    <!-- 'Loading' box -->
    <div class="row" v-if="namespace && namespace.length == 0 && loading_filelist">
        <div class="col-3"></div>
        <div class="col-12 col-lg-6">
            <hero-box :bg-class="'bg-gradient-primary'" :icon="'loader d-block'"></hero-box>
        </div>
    </div>

</div>



<!-- File list filter (TODO should not be a modal) -->
<div class="modal modal-right fade" id="filter-modal">
    <div class="modal-dialog modal-lg">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="mt-0 modal-title"><span>Filter Files</span></h4>
                <div class="float-right clickable" data-dismiss="modal"><em class="ion-close-round text-soft"></em></div>
            </div>
            <div class="modal-body">

                <p>Types</p>
                <div>
                    <button
                        class="btn btn-sm btn-outline-primary text-uppercase m-1"
                        :class="{ 'btn-primary': list_filters.types.includes(ext) }"
                        v-for="(ext, idx) in file_types" :key="idx"
                        @click="toggle_filter('types', ext)">
                        {{ ext }}
                    </button>
                </div>
                <!--TODO add more filters-->

            </div>
        </div>
    </div>
</div>

<input type="file" id="file_upload" style="display:none" multiple @change="files_selected" />
<input type="file" id="folder_upload" style="display:none" webkitdirectory @change="folder_selected" />

</section>
</template>


<script>

import { NamespaceService } from '@/services/namespace-service.js'
import { FileVersionService } from '@/services/fileversion-service.js'
import { StorageBackendService } from '@/services/storage_backend-service.js'
import { ShareService } from '@/services/share-service.js'
import { Utils } from '@/helpers/utils.js'
import { bus, events } from '@/helpers/event_bus.js'
import pageActivity from '@/mixins/page-activity'
import heroBox from '@/components/hero-box.vue'
import modifiedBox from '@/components/modified-box.vue'
import { FileUploader } from '@/helpers/file-uploader.js'
import fileInfoVersionsShares from '@/components/file-info-versions-shares.vue'
import platform from "platform"
import md5 from 'md5'
import { useResponsive } from '@/helpers/useResponsive';

// Global limit on the number of parallel file uploads and downloads
const MAX_PARALLEL_UPLOADS = 4
const MAX_PARALLEL_DOWNLOADS = 4

const MAX_FOLDERS_AND_FILES_UPLOAD = 1000
const MAX_PATH_LENGTH = 4096

const NAMESPACE_RELOAD_PERIOD_MS = 10000 // 10 sec
let ENABLE_NAMESPACE_REFRESH = true

export default {

    mixins: [pageActivity],

    components: {
        modifiedBox,
        heroBox,
        fileInfoVersionsShares
	},

    props: {
        user: [Object, null], // null before it's loaded
        shareAllowed: {type: Boolean, default: true},
        uploadAllowed: {type: Boolean, default: true},
        downloadAllowed: {type: Boolean, default: true},
        namespaceOpsAllowed: {type: Boolean, default: true},
        modifiedBoxExternal: [Object, null], // User-like object (name/email_address, avatar_url) to display as the uploader when user_id=0
        is_admin_folder: {type: Boolean, default: false}
    },

    data() {
        return {
            show_clouds_ready_box: false,
            window: window,
            new_folder_mode: false,
            new_folder_loading: false,
            new_folder_name: null,

            nav_stack: [],
            ignore_hashchange: false,
            loading_filelist: false,

            list_sort: { attr: 'name', asc: true },
            list_filters: { types: [] },
            file_upload_el: null,
            folder_upload_el: null,

            buckets: null,

            uploading_files_ctr: 0,
            upload_queue: [],
            download_queue: [],

            highlight_file_id: null,
            dropzone_active: false,

            namespace: [],
            ns_reload_handler: null,

            is_view_destroyed: false,

            team_members_here: [],

            /* File Multiselect */
            select_all: false,
            last_selected_file_idx: null, /** Track which file index last selected, for Shift-click selecting all between last and currently selected  */
            files_multidownload_in_progress: false,
        }
    },

    computed: {

        user_team(){
            // for watch user_team
            return this.user?.team || null
        },

        file_types(){
            // Collect all different file extensions
            let types = this.contents.filter(file => file.entity_type == NamespaceService.ENTITY_TYPE_FILE).map(f => f.extension)
            types = Utils.unique_array(types).filter(ext => ext && ext.length).map(ext => ext.toUpperCase())
            types.sort()
            return types
        },

        current_dir(){
            // Last item of the nav stack
            return this.nav_stack.length > 0 ? this.nav_stack[this.nav_stack.length-1] : {}
        },

        current_folder_id(){
            // Note that the root folder should be 'null' here, but it's represented by '-1' in the namespace
            return (!this.current_dir || this.current_dir.id == -1) ? null : this.current_dir.id
        },

        contents(){
            // Contents of the current folder (both files and folders)
            if(!this.namespace || !this.current_dir){ return [] }
            return this.namespace.filter(en => en.parent_id == this.current_folder_id)
        },

        folders(){
            // Folders of 'contents', sorted by name
            return Utils.sortByKeys(this.contents.filter(item => item.entity_type == NamespaceService.ENTITY_TYPE_FOLDER), 'name')
        },

        files(){
            // Files of 'contents', filtered and sorted
            let files = this.contents.filter(file => file.entity_type == NamespaceService.ENTITY_TYPE_FILE)
            
            // Apply filters
            if(this.list_filters.types.length) {
                files = files.filter(file => file.extension && this.list_filters.types.map(ext => ext.toLowerCase()).includes(file.extension.toLowerCase()))
            }
            // Sort and return
            return Utils.sortByKeys(files, this.list_sort.attr, !this.list_sort.asc)
        },

        selected_files(){ return this.files.filter(f => f.selected)},
        is_mobile(){ return useResponsive().isMobile },

        upload_queue_length(){ return this.upload_queue.length },
        download_queue_length(){ return this.download_queue.length },

        disable_upload(){ return this.uploadAllowed === false },
        disable_download(){ return this.downloadAllowed === false },
        disable_share(){ return this.shareAllowed === false || (this.user && this.user.team_settings && this.user.team_settings.config.share_enabled === false) },
        disable_namespace_ops(){ return this.namespaceOpsAllowed === false },

        // Hide multi-select checkboxes when nothing can be done with files
        multiselect_disabled(){ return this.disable_download && this.disable_namespace_ops && this.disable_share },

        // Hide 'share' menu item in folders if folder sharing is disabled
        folder_shares_enabled(){
            return this.user?.team_settings?.config?.share_folder_share_enabled || false
        },

        cached_ns_key(){
            // For namespaces without password: 'ns-default', 'ns-admin_folder'
            // Namespaces with password: 'ns-client_space-42g3uiz423hv' (last section is the md5 of the pass)
            return "ns-" + (NamespaceService.ns_type ? NamespaceService.ns_type : 'default') + (NamespaceService.ns_key ? '-'+md5(NamespaceService.ns_key) : "" )
        },

        is_desktop_safari(){
            return platform &&
                    platform.os &&
                    platform.os.family &&
                    platform.os.family.toLowerCase() == "os x" &&
                    platform.name &&
                    platform.name.toLowerCase() == "safari"
        },

        is_client_space_client(){
            if(!this.user){
                return null
            }
            if(this.user.is_client_space_client === undefined){
                return false
            }
            return this.user.is_client_space_client
        }

    },

    watch: {

        upload_queue_length(newVal, oldVal){
            if(newVal > 0){
                window.onbeforeunload = function(){ return "Some files are still uploading, please wait before you leave!" }
            }
            if(oldVal > 0 && !newVal){
                window.onbeforeunload = null
            }

            // Count how many files are uploading right now
            const uploading_num = this.upload_queue.filter(el => el.is_uploading).length

            // Find out if there are theoratical free slots
            const free_slots = MAX_PARALLEL_UPLOADS - uploading_num

            // Start the upload until there are non-uploading files left
            for(var i=0 ; i<Math.min(free_slots, this.upload_queue.length-uploading_num) ; ++i){
                let files_waiting = this.upload_queue.filter(el => !el.is_uploading)
                if(!files_waiting.length) break 
                let new_file_to_start = files_waiting[0]
                new_file_to_start.is_uploading = true
                this.upload_file(new_file_to_start.file, new_file_to_start.userfile)
            }
        },

        download_queue_length(newVal, oldVal){
            if(newVal > 0){
                window.onbeforeunload = function(){ return "Some files are still downloading, please wait before you leave!" }
            }

            if(oldVal > 0 && newVal == 0){
                Utils.show_success("All files downloaded successfully.")
                window.onbeforeunload = null

                this.files_multidownload_in_progress = false
            }

            // Count how many files are uploading right now
            const downloading_num = this.download_queue.filter(el => el.is_downloading).length

            // Find out if there are theoratical free slots
            const free_slots = MAX_PARALLEL_DOWNLOADS - downloading_num

            // Start the download until there are non-downloading files left
            for(var i=0 ; i<Math.min(free_slots, this.download_queue.length-downloading_num) ; ++i){
                let files_waiting = this.download_queue.filter(el => !el.is_downloading)
                if(!files_waiting.length) break 

                let new_file_to_start = files_waiting[0]
                new_file_to_start.is_downloading = true
                this.download_file(new_file_to_start.file)
            }
        },

        'current_folder_id'(){
            this.load_folder_contents()
        },

        disable_upload(){
            if(this.disable_upload){
                // Disable auto-refresh if the namespace cannot change
                ENABLE_NAMESPACE_REFRESH = false
            }
        },

        is_client_space_client(){
            // Load the buckets if we know for sure that the user is not a client
            // (before the user object is set, this.is_client_space_client is NULL)
            if(this.is_client_space_client === false){
                StorageBackendService.get_buckets().then( res => {
                    this.buckets = res.body
                }).catch(err_resp => {
                    console.error("Failed to retrieve buckets: ", err_resp)
                })
            }
        },

        selected_files(){
            // Selected files of the current folder
            return this.files.filter(f => f.selected)
        },

        select_all(newval){
            // 'Select All' checkbox is changed
            this.files.forEach(f => f.selected = newval)
        },

    },

    created(){

        // Load namespace from local cache
        this.load_cached_namespace()
        this.load_folder_from_hash()

        // Show warning for outdated Safari users
        if(this.is_desktop_safari && !localStorage.getItem('safari_warning')){
            const version_string = platform.version.toLowerCase()
            if(version_string.startsWith("10.") || version_string.startsWith("11.")){
                const sticky = true
                Utils.show_warning("<b>Warning!</b> Other SkyFlok users reported file download problems in this browser (Safari 10 & 11).<br/>If you cannot download files, please try to upgrade Safari to the latest version, or use Chrome, Firefox or Opera!", sticky)
                localStorage['safari_warning'] = 1
            }
        }

        // Set up event listeners
        var self = this
        window.onhashchange = function(){
            if(self.ignore_hashchange){
                // The hash change was triggered by our code, it should not be acted upon.
                // Reset the flag
                self.ignore_hashchange = false
            }
            else{
                self.load_folder_from_hash()
            }
        }

        // Event listeners
        bus.$on(events.HIGHLIGHT_FILE, function(file_id){
            self.highlight_file_id = file_id
            self.highlight_file()
        })

        bus.$on(events.REMOVE_FROM_FILELIST, function(entity){
            // Called when a file/folder was drag&dropped to the recycle bin menu item and 
            // need to be deleted from the local namespace
            var idx = self.namespace.findIndex(en => entity.id == en.id)
            if(idx < 0){ return }
            self.namespace.splice(idx, 1)
            self.cache_namespace()
        })

        bus.$on(events.FILELIST_CHANGE_FOLDER_TO, function(location_hash){
            self.ignore_hashchange = true
            window.location.hash = location_hash
            self.load_folder_from_hash()
        })

        bus.$on(events.FILELIST_CHANGE_FOLDER_TO_ID, function(folder_id, path){
            const target_folder = folder_id && folder_id > 0 ? self.namespace.find(f => f.id == folder_id) : {id: -1}
            self.change_folder_to(target_folder)
            self.ignore_hashchange = true
            window.location.hash = path
        })

        bus.$on(events.COPY_MOVE_COMPLETED, () => {
            // Reload the entire namespace
            this.reload_namespace()
        })

    },

    mounted(){
        var self = this
        this.file_upload_el = document.getElementById("file_upload")
        this.folder_upload_el = document.getElementById("folder_upload")

        // Load namespace contents (periodic reload is set up in onPageActivityChange)
        this.reload_namespace()

        // Show dropzone when something is dragged over the window
        // Note: the drop zone must be 100% x 100% so we can hide it on dragleave
        window.addEventListener('dragenter', self.dragenter_listener)
        window.addEventListener("keyup", this.onKeyUp)

        bus.$on(events.ENTITIES_SHARED, (entity_ids) => {
            // Invoked by the share form when a new share was created with entity_ids
            this.onNewShare(entity_ids)
        })

    },

    unmounted(){
        window.removeEventListener('dragenter', this.dragenter_listener)
    },

    beforeDestroy(){

        this.is_view_destroyed = true

        // Clear event listeners listener
        window.onhashchange = null
        window.removeEventListener('dragenter', this.dragenter_listener)
        window.removeEventListener("keyup", this.onKeyUp)

        window.onbeforeunload = null
    },

    methods: {

        onPageActivityChange() {
            // Invoked when the Skyflok webapp lost focus or came back
            // (overrides the onPageActivityChange function from)
            if (this.isPageActive) {
                // SkyFlok webapp became active
                // reload the namespace immediately
                this.reload_namespace()

                // Set up periodic refresh
                if(this.ns_reload_handler)  return // periodic reload already set up
                else if(ENABLE_NAMESPACE_REFRESH){
                    this.ns_reload_handler = setInterval(this.reload_namespace, NAMESPACE_RELOAD_PERIOD_MS)
                }
            } 
            else {
                // SkyFlok webapp is no longer active
                // Stop periodically updating namespace when the tab loses focus
                if(this.ns_reload_handler){
                    clearInterval(this.ns_reload_handler)
                    this.ns_reload_handler = null
                }
            }
        },

        onKeyUp(evt){
            if(!evt) return
            switch(evt.key){
                case "Escape":
                    // If the new folder box is open, close it
                    if(this.new_folder_mode) this.new_folder_form(false)
                    break
                default: break
            }
        },

        dragenter_listener(){
            this.dropzone_active = true
        },

        get_folderbox_class(folder) {
            const is_empty = !this.namespace.find(en => en.parent_id == folder.id)
            return `color-${Utils.string_to_color(folder.name)}-${is_empty ? '200' : '400'}`
        },

        cache_namespace(){
            if(!this.namespace){ return }
            const namespace_sanitized = this.namespace.map(el => {
                // Replace entity type string with an int
                let entity_type = 0;
                switch(el.entity_type){
                    case NamespaceService.ENTITY_TYPE_FOLDER: entity_type = 0; break;
                    case NamespaceService.ENTITY_TYPE_FILE: entity_type = 1; break;
                    default: entity_type = el.entity_type
                }
                // Serialize namespace to a much more compact representation
                // exclude parent ID for root entities 
                return el.parent_id 
                            ? [el.id, el.name, entity_type, el.parent_id] 
                            : [el.id, el.name, entity_type]
            })

            try{
                localStorage.setItem(this.cached_ns_key, JSON.stringify(namespace_sanitized))
            } catch(ex){
                console.error("Error caching namespace: ", ex)
                // Avoid inconsistent state
                localStorage.setItem(this.cached_ns_key, [])
                throw ex
            }
        },

        load_cached_namespace(){
            const ns_string = localStorage.getItem(this.cached_ns_key, null)
            if(!ns_string){ return }

            try {
                let namespace = []
                JSON.parse(ns_string).forEach(row => {
                    // Do not load pending stuck files
                    // if(row[0] < 0){ return }

                    // Parse entity type
                    let entity_type = 0;
                    switch(row[2]){
                        case 0: entity_type = NamespaceService.ENTITY_TYPE_FOLDER; break;
                        case 1: entity_type = NamespaceService.ENTITY_TYPE_FILE; break;
                        default: entity_type = row[2]
                    }
                    namespace.push({
                        id: row[0],
                        name: row[1],
                        entity_type: entity_type,
                        parent_id: row.length == 3 ? null : row[3]
                    })
                })
                this.namespace = namespace
            } catch (error) {
                console.error("Cached namespace is corrupt, removing")
                localStorage.removeItem(this.cached_ns_key)
            }


        },

        async reload_namespace(){

            // Reloads the fresh contents of the whole namespace
            this.loading_filelist = true
            const fresh_contents = await NamespaceService.get_all_namespace().then(res => res.body).catch(err => {
                console.error("Error in NamespaceService.get_all_namespace: ", err)
                Utils.show_error("Error reloading files & folders from server! Please refresh the page in a few minutes.")
                return null
            }).finally(() => {
                this.loading_filelist = false
            })
            if(fresh_contents === null) return

            // Remove items from namespace that are not in the fresh contents (and not being uploaded with negative ID)
            this.namespace.map((entity, idx) => entity.id > 0 && !fresh_contents.map(en => en.id).includes(entity.id) ? idx : null).filter(idx => idx)
                .sort().reverse() // Indexes must be in reverse order (highest first), so we can delete them one by one without invalidating the rest
                .forEach(deleted_idx => this.namespace.splice(deleted_idx, 1))// Delete removed from local namespace

            // Existing entities: update name, and parent ID (maybe it was renamed or moved)
            fresh_contents.forEach(fresh_entity => {
                const local_entity = this.namespace.find(en => en.id == fresh_entity.id)
                if(!local_entity) return // New entity, will be added

                if(local_entity.name != fresh_entity.name){
                    local_entity.name = fresh_entity.name
                    // Parse the new name to display name and extension
                    this.init_file(local_entity, true)
                }
                local_entity.parent_id = fresh_entity.parent_id
            })

            // Add new entities
            this.namespace.push(...fresh_contents.filter(entity => !this.namespace.map(en => en.id).includes(entity.id)))

            // Cache
            this.cache_namespace()
            
            // Load versions of the current folder contents
            this.load_folder_contents()

            // Load active shares num
            this.add_shares_num()
        },

        init_contents(arr){
            if(arr === undefined){
                arr = this.contents
            }
            arr.forEach(el => {
                switch(el.entity_type){
                    case NamespaceService.ENTITY_TYPE_FILE:
                        this.init_file(el)
                        break
                    case NamespaceService.ENTITY_TYPE_FOLDER:
                        this.init_folder(el)
                        break;
                }
            })
        },

        init_file(basic_file, force_update=false){
            // When force_update is true, file extension, mime type and viewer are updated even if they were set before

            // Set boolean flags
            if(basic_file.show_details === undefined){ this.$set(basic_file, 'show_details', false) }
            if(basic_file.loading === undefined){ this.$set(basic_file, 'loading', false) }
            if(basic_file.selected === undefined){ this.$set(basic_file, 'selected', false) }

            // Extension, mime type, viewer
            if(force_update || !basic_file.extension){ 
                // Split the file name to display name and extension
                const filename = basic_file.name
                let parts = {name: '', ext: ''}
                const lastDot = filename.lastIndexOf('.');
                
                // If filename starts with a dot and has no other dot (e.g. ".DS_Store"), it becomes the name
                if (lastDot <= 0) {
                    parts.name = filename
                }
                else{
                    parts.name = filename.slice(0, lastDot)
                    parts.ext = filename.slice(lastDot + 1)
                }
                this.$set(basic_file, 'display_name', parts.name) 
                this.$set(basic_file, 'extension', parts.ext) 
            }
            if(force_update || !basic_file.mime_type){ this.$set(basic_file, 'mime_type', Utils.get_mime_type(basic_file.extension)) }
            if(force_update || !basic_file.viewer){ 
                this.$set(basic_file, 'viewer', Utils.get_file_viewer(basic_file, this.is_mobile, platform.name.toLowerCase())) }
        },

        init_folder(basic_folder, force_update){
            // When force_update is true, folder color is updated even if it was set before, e.g. on rename
            if(force_update === undefined){ force_update = false  }
            if(basic_folder.dragover === undefined){ this.$set(basic_folder, 'dragover', false) }
            basic_folder.color = Utils.string_to_color(basic_folder.name)
        },

        load_folder_contents(){
            // When contents change, reload the displayed file details
            this.init_contents()
            this.load_file_versions()
        },

        load_file_versions(){
            // Loads the versions of the currently displayed files
            let file_ids = this.files
                .filter(f => f.id > 0)
                .map(file => file.id)

            if(!file_ids.length) return

            FileVersionService.get_latest_info_with_count(file_ids).then(res => {
                const latest_with_count = res.body
                if(!latest_with_count){ return }

                this.files.forEach(file => {
                    const version = latest_with_count.find(i => i.file_id == file.id )
                    if(!version) return 

                    this.$set(file, 'versions_num', version.versions_num)
                    this.$set(file, 'size', version.size)
                    this.$set(file, 'last_modified_by', version.user_id)
                    this.$set(file, 'last_modified', version.timestamp)
                })

            }).catch(err => {
                console.error("Error loading latest with count: ", err)
                Utils.show_error("Error loading file versions")
            })
        },

        async add_shares_num(){
            // Shares are only in Team Files
            if(NamespaceService.ns_type !== NamespaceService.NS_TYPE_DEFAULT) return
            // When a namespace is loaded, this method sets the 'shares_num' field of each file (and folder)
            const list_active_shares_only = true
            const shares = await ShareService.list_shares(list_active_shares_only).then(res => res.body).catch(err => {
                console.log("Error loading shares ", err)
                return null
            })
            if(shares == null) return

            this.namespace.forEach(entity => {
                this.$set(entity, 'shares_num', shares.filter(s => s.contents.includes(entity.id)).length) 
            })
        },

        change_folder_to(target_folder){

            // If the new folder is already on the top of the stack (=we are standing there), ignore
            if(this.nav_stack.length && this.nav_stack[this.nav_stack.length-1].id == target_folder.id){
                return
            }
            // Close new folder box if empty
            this.new_folder_mode = false
            // Clear multi-select
            this.multiselect_clear()

            // Handle nav stack
            // check if the new folder is on the stack (= jump back)
            const el_idx = this.nav_stack.findIndex(el => el.id == target_folder.id)
            if(el_idx >= 0){
                // A folder on the stack is selected, clear everything after the current el
                // E.g. when the stack is this: [home] -> Folder1 -> Folder2 -> Folder3
                // and the user clicks on Folder1, then delete Folder2 and Folder3
                this.nav_stack.splice(el_idx+1)
            }
            else{
                // A subfolder of the previous folder is selected, add it to the stack
                this.nav_stack.push(target_folder)
            }

            // Set the hash to the path string
            let new_path = ""
            this.nav_stack.forEach(f => { if(f.id && f.id > 0){ new_path += "/"+ encodeURIComponent(f.name) } })

            this.ignore_hashchange = true
            window.location.hash = new_path
        },

        load_folder_from_hash(){
            
            const getFoldersFromHash = () => {
                // Parses the location hash to a list of decoded folder names
                // e.g., #/Mobile%20test/Test -> ['Mobile test', 'Test']
                const hash = window.location.hash; 
                const path = hash.startsWith('#/') ? hash.slice(2) : hash.slice(1);
                if (!path) return [];
                return path.split('/').map(decodeURIComponent);
            }
            
            const folderPath = getFoldersFromHash();
            
            // Construct nav stack
            this.nav_stack = [{ id: -1, path: "", parent_id: null, name: "" }];
            let parentId = null; // root
            for (const segment of folderPath) {
                const match = this.namespace.find(
                entry =>
                    entry.entity_type === NamespaceService.ENTITY_TYPE_FOLDER &&
                    entry.name.toLowerCase() === segment.toLowerCase() &&
                    entry.parent_id === parentId
                );

                if (match) {
                    this.nav_stack.push(match);
                    parentId = match.id;
                } else {
                    // stop if the segment doesn't match, change the hash to the deepest valid path
                    const valid_path = this.nav_stack.map(f => f.name).join('/')
                    this.ignore_hashchange = true
                    window.location.hash = valid_path
                    Utils.show_error(`Folder ${folderPath.join('/')} does not exist any more, showing ${valid_path}`, true)
                    break;
                }
            }
        },


        folderbox_dropdown(trigger_el_id){
            $('#'+trigger_el_id).dropdown('toggle')
        },

        something_dropped(evt){
            evt.preventDefault()
            if(this.disable_upload){ return; }
            
            if(evt.dataTransfer &&
            evt.dataTransfer.types &&
            evt.dataTransfer.types.length == 1 &&
            evt.dataTransfer.types[0].toLowerCase() == 'files'){
                // File(s) were dropped (TODO make show_info instead)
                Utils.show_info(`Uploading ${evt.dataTransfer.files.length} file(s)...`)
                this.files_selected(evt)
            }
            // Hide the dropzone even if something else was dropped
            this.dropzone_active = false
        },
        /*
        TODO fix dragging and dropping files and folders to a folder (move) or the recycle bin (delete)

        drag(evt, entity){
            if(this.disable_namespace_ops){ return }
            evt.dataTransfer.setData("text/plain", JSON.stringify(entity))
            evt.dataTransfer.setData("application/vnd.skyflok", JSON.stringify({is_skyflok_entiy: true}))
            evt.dataTransfer.dropEffect = "move"
            bus.$emit(events.FILE_FOLDER_DRAG_START)
        },

        dragend(){
            if(this.disable_namespace_ops){ return }
            bus.$emit(events.FILE_FOLDER_DRAG_END)
        },

        drop(evt, folder){
            if(this.disable_namespace_ops){ return }

            folder.dragover = false
            if(!evt.dataTransfer || !evt.dataTransfer.getData("text")){ return }
            const dropped = JSON.parse(evt.dataTransfer.getData("text"))
            if(!dropped || !dropped.id || !dropped.entity_type || !folder){ return }
            // Prevent moving into the already parent or itself
            if(dropped.parent_id == folder.id || dropped.id == folder.id){ return }

            var dropped_entity = this.contents.find(el => el.id == dropped.id)
            this.$set(dropped_entity, 'loading', true)

            var self = this
            NamespaceService.move_entity(dropped.id, folder.id).then(() => {
                bus.$emit(events.SHOW_ALERT, {message: dropped.name + " moved successfully to " + (folder.name || "HOME")})
                dropped_entity.loading = false
                // find file or folder and remove it
                var idx = self.namespace.findIndex(el => el.entity_type == dropped.entity_type && el.id == dropped.id)
                if(idx < 0){ console.error("Cannot find moved entity ", dropped); return }
                self.namespace.splice(idx, 1)
                self.cache_namespace()
            }).catch(err => {
                console.error(err)
                dropped_entity.loading = false
                bus.$emit(events.SHOW_ALERT, {message: "Failed to move " + dropped.name + " to " + (folder.name || "HOME") + ": " + err.body.message, type: "danger"})
            })
        },
        */

        highlight_file(){
            if(!this.highlight_file_id){ return; }
            var file = this.files.find(f => f.id == this.highlight_file_id )
            if(file){
                // un-highlight all files
                this.files.forEach(f => { this.$set(f, 'highlighted', false) })
                this.$set(file, 'highlighted', true)

                $(".main-container")[0].scrollTop = 0
                $(".main-container").animate({
                    scrollTop: ($("#file-row-"+file.id).offset().top - 200)
                }, 500)
            }
        },

        remove_file_highlight(){
            this.namespace.forEach(f => {
                this.$delete(f, 'highlighted')
            })
        },

        multiselect(event, file_idx) {
            /* Handler of multi-selecting files */
            if(this.multiselect_disabled) return
            
            if (event.shiftKey && this.last_selected_file_idx != null) {
                // Shift-click, select/deselect all files between the clicked and the last selected
                
                if (window.getSelection) {
                    // Prevent browser text selection during shift-click
                    const selection = window.getSelection();
                    if (selection && selection.type === 'Range') {
                        selection.removeAllRanges();
                    }
                }
                // Determine selection range
                const [start, end] = [this.last_selected_file_idx, file_idx].sort((a, b) => a - b);
                // The new selected state of the entire range will be based on the clicked file's state
                const newState = !this.files[file_idx].selected; 
                // Set new state for the whole range
                for (let i = start; i <= end; i++) {
                    this.files[i].selected = newState
                }
            } else {
                // Normal click: toggle selected manually
                this.files[file_idx].selected = !this.files[file_idx].selected
            }
            // Record last clicked file idx
            this.last_selected_file_idx = file_idx;
        },

        multiselect_clear() { 
            // Clears multi-select
            this.files.forEach(f => f.selected = false) 
            this.select_all = false
            this.last_selected_file_idx = null
        },

        copy_move_file(action, file){
            /**
             * Opens the target selector modal dialog (folder tree) when the user clicks on
             * the Move or Copy button of a file, files or folder
             * 
             * @param action What is the triggered operation, one of:
             *  - 'copy_file': Copy a file 
             *  - 'move_file': Move a file
             *  - 'move_folder': Move a folder
             *  (copy folder and batch folder operations not supported)
             * @param file Target File or Folder to be moved/copied
             */
            if(this.disable_namespace_ops) return // operation not allowed
            if(!file) return // batch operation but nothing is selected
            
            bus.$emit(events.OPEN_COPY_MOVE, {action, file})
        },


        rename_file(file){
            if(this.disable_namespace_ops){ return }
            this.$set(file, 'rename', {
                name: file.name,
                id: file.id,
                loading: false,
                error: false
            })

            // Select the name part (before extension)
            this.$nextTick(()=>{
                this.select_file_name("file-rename-"+file.id, file.rename.name)
            })
        },

        rename_submit(file){
            // 'file' can be either a File or a Folder!
            if(this.disable_namespace_ops){ return }

            file.rename.loading = true
            file.rename.error = false
            var self = this

            NamespaceService.rename_file(file.id, file.rename.name).then(res => {
                // apply change
                file.name = res.body.name;
                // hide form
                file.rename = false

                if(file.entity_type == NamespaceService.ENTITY_TYPE_FILE){
                    this.init_file(file, true)
                }
                else if(file.entity_type == NamespaceService.ENTITY_TYPE_FOLDER){
                    this.init_folder(file, true)
                }
            })
            .catch(err => {
                console.error(err)
                file.rename.loading = false;
                file.rename.error = err.body.message
                self.select_file_name("file-rename-"+file.id, file.rename.name)
            })
        },

        select_file_name(el_id, filename){
            let field = document.getElementById(el_id)
            if(!field){ return }
            const start = 0;
            const tmp = filename.lastIndexOf(".")
            const end = tmp < 0 ? filename.length : tmp
            if(field.createTextRange){
                var selRange = field.createTextRange();
                selRange.collapse(true);
                selRange.moveStart('character', start);
                selRange.moveEnd('character', end);
                selRange.select();
                field.focus();
            } else if( field.setSelectionRange ) {
                field.focus();
                field.setSelectionRange(start, end);
            } else if( typeof field.selectionStart != 'undefined' ) {
                field.selectionStart = start;
                field.selectionEnd = end;
                field.focus();
            }

        },

        close_modal(el_id){
            $("#"+el_id).modal("hide")
        },

        toggle_filter(key, ext){
            switch(key){
                case 'types':
                    {
                        const arr = this.list_filters.types
                        const tmp = arr.indexOf(ext);
                        tmp < 0 ? arr.push(ext) : arr.splice(tmp, 1)
                        break;
                    }
            }
        },

        sort_by(attr){
            if(attr == this.list_sort.attr){ this.list_sort.asc = !this.list_sort.asc }
            else{ this.list_sort.attr = attr; this.list_sort.asc = true }
        },

		async delete_file(entity){
            /**
             * Put a specific file or folder, or the curretly selected batch of files to the Recycle Bin
             * 
             *  @param entity The file or folder object that is being deleted. 
             *      When not set, the currently selected files are deleted.
             */
            
            if(this.disable_namespace_ops){ return }

            if(!entity && !this.selected_files.length){
                console.error("Nothing to delete")
                return
            }

            // What to delete: the passed file/folder or all files that are selected
            const entities_to_delete = entity ? [entity] : this.selected_files
            
            // Define a shorthand function to set the loading state of all affected entities
            const set_deleted_entities_loading = (newval) => entities_to_delete.forEach(e => e.loading = newval)

            // Set loading=true
            set_deleted_entities_loading(true)
            
            // #region Check if any of the entities are shared and display warning before deleting it
            const active_shares_arr = await ShareService.get_shares_num(entities_to_delete.map(e => e.id))
                                                .then(res => res.body)
                                                .catch(() => []) // This call fails if the logged in user is a Client. Since client space files cannot be shared, return an empty array on error.
            const shared_entity_ids = active_shares_arr.filter(s => s.active_shares_num > 0)
            if(shared_entity_ids.length) {
                // At least one entity has active shares, show a confirm dialog to continue
                // The dialog text structure depends on whether it's a single file/folder delete or batch
                let confirm_text = ""
                if(entities_to_delete.length == 1){
                    // Single file/folder
                    confirm_text = `${entities_to_delete[0].name} is shared, if you delete it people will lose access. Sure you want to delete it?`
                }
                else{
                    // Batch delete
                    confirm_text = `${shared_entity_ids.length} of ${entities_to_delete.length} files ${shared_entity_ids.length == 1 ? 'is' : 'are'} shared, if you delete them people will lose access. Sure you want to delete the files?`
                }

                if(!confirm(confirm_text)){
                    // Set loading=false
                    set_deleted_entities_loading(false)
                    return
                }
            }
            // #endregion

            // Delete
            const promise = entities_to_delete.length == 1 && entities_to_delete[0].entity_type == NamespaceService.ENTITY_TYPE_FOLDER 
                                ? NamespaceService.delete_entity(entities_to_delete[0].id)
                                : NamespaceService.delete_files_batch(entities_to_delete.map(e => e.id))

            await promise.then(res => {
                // `delete_entity` returns Null
                // `delete_files_batch` returns the file IDs that could not be deleted under the `ids_not_deleted` key
                const non_deleted_ids = res.body?.ids_not_deleted || []
                if(!non_deleted_ids.length){
                    // Show success message if all entities were deleted successfully
                    const what_was_deleted = entities_to_delete.length == 1 ? entities_to_delete[0].name : `${entities_to_delete.length} files`
                    Utils.show_success(`${what_was_deleted} moved to Recycle Bin`)
                }
                else{
                    // Batch file delete with partial success, show warning
                    let missing_files_list = "<ul>"
                    entities_to_delete.filter(e => non_deleted_ids.includes(e.id)).map(e => e.name).forEach(file_name => {
                        missing_files_list += `<li>${file_name}</li>`
                    })
                    missing_files_list += "</ul>"

                    Utils.show_warning(`${non_deleted_ids.length} of ${entities_to_delete.length} files are no longer here and were not deleted:<br/>${missing_files_list}`)
                }

                // Remove the files that were successfully deleted
                const deleted_entity_ids = entities_to_delete.map(e => e.id).filter(file_id => !non_deleted_ids.includes(file_id))
                deleted_entity_ids.forEach(entity_id => {
                    const idx = this.namespace.findIndex(el => el.id == entity_id)
                    if(idx < 0) return // not in this namespace any more
                    this.namespace.splice(idx, 1)
                })
                // Update the locally cached NS contents
                this.cache_namespace()
            })
            .catch(err => {
                console.error(`Error deleting ${entities_to_delete.length} entities: `, err)
                Utils.show_error(`Error: ${err.body?.message || 'Internal error'}`)
            })
            .finally(() => set_deleted_entities_loading(false))
            
		},

        files_selected(evt, files, parent_folder_id){
            // Called when files are picked via the system file picker dialog or dropped to the File List view
            // Adds valid files (not folders or other dropped shit) to the upload queue

            if(this.disable_upload){ return }

            files = files ? files : evt.target.files || evt.dataTransfer.files;

            if (!files || !files.length){ return; }

            var self = this

            for(var i=0 ; i<files.length ; ++i){
                const userfile = files[i]

                if(!userfile.name || userfile.name == ''){
                    Utils.show_error("File '"+userfile.name+"' has no name!")
                    continue
                }
                if(!userfile.size || userfile.size == 0){
                    Utils.show_error("Empty file '"+userfile.name+"' cannot be uploaded!")
                    continue
                }

                // Try to read the file so we can reject dropped folders
                var reader = new FileReader()
                reader.onloadend = function(evt){
                    // Finished reading generation
                    const buffer = evt.target.result

                    if(!buffer || buffer.byteLength == 0){
                        // This is a folder!
                        Utils.show_warning("<b>Please drop files here, not a folder.</b> Folder upload is coming soon!")
                        return;
                    }

                    // OK, this is a real file

                    // Try to find existing FileList item
                    let file_record = self.files.find( f => f.name.toLowerCase() == userfile.name.toLowerCase() )
                    if(!file_record) {
                        // New file upload, we need to construct the file list item manually
                        const temp_file_id =  (++self.uploading_files_ctr) * -1
                        file_record = {
                            id: temp_file_id,
                            entity_type: NamespaceService.ENTITY_TYPE_FILE,
                            name: userfile.name,
                            size: userfile.size,
                            parent_id: parent_folder_id ? parent_folder_id : self.current_folder_id,
                            loading: true,
                            last_modified_by: self.user.id,
                            versions_num: 0,
                            shares_num: 0
                        }
                        self.init_file(file_record)

                        // Add to file list
                        self.namespace.push(file_record)
                    }
                    else{
                        // it's an existing File from the list, just update its size
                        file_record.loading = true
                        file_record.size = userfile.size
                    }

                    self.upload_queue.push({
                        file: file_record,
                        userfile: userfile,
                        is_uploading: false
                    })
                }
                reader.readAsArrayBuffer(userfile.slice(0, 10))
            }
            this.file_upload_el.value = ""
        },

        folder_selected(evt) {
            //Called when folders are picked via the system folder picker dialog.
            if(this.disable_upload){ return }

            const files = Array.from(evt.target.files)

            if(!files || !files.length){ return; }

            /**
             * folder_paths[] contains the paths that the files from the evt has. I.E ["rootfolder", rootfolder/subfolder", "rootfolder/subfolder/subsubfolder"] if
             * every folder contains one or more files. If for example "subfolder" wouldn't contain file(s), folder_paths would be ["rootfolder", "rootfolder/subfolder/subsubfolder"].
             * Note that if any folder name has an illegal character in it, the backend will automatically replace it with an underscore '_'
             */
            const paths = {}
            for (var i=0 ; i<files.length ; ++i) {
                const filepath = files[i].webkitRelativePath
                const folderpath = filepath.substring(0, filepath.lastIndexOf('/'))
                if(folderpath.length > MAX_PATH_LENGTH){
                    Utils.show_error(`Paths with more than ${MAX_PATH_LENGTH} characters are not supported! Problematic folder: ${folderpath}`)
                    return;
                }
                paths[folderpath] = true
            }
            // Replace ':' with '_'. This is necessary because macOS allows '/' to be in file and folder names,
            // but the browsers replace it with ':' before giving access to the file or folder to the webapp.
            // Namespace Service converts ':' to '_' automatically, so the returned folder names will have '_' in them
            // and therefore not found later whne 
            const folder_paths = Object.keys(paths).map(path => path.replace(/:/g, '_'))

            if(files.length + folder_paths.length > MAX_FOLDERS_AND_FILES_UPLOAD){
                Utils.show_error(`Folder uploads are currently limited to ${MAX_FOLDERS_AND_FILES_UPLOAD}. Folder ${folder_paths[0]} contains ${files.length + folder_paths.length} files and folders.`)
                return; 
            }

            // Create folders first
            const parent_id = this.current_dir.id
            NamespaceService.create_folders(folder_paths, parent_id).then(res => {
                let new_folders = res.body

                // Create dict that stores ids of all created directory paths
                let folder_paths = {}

                // Loops over all folders in response and adds the paths to our directory of folder paths
                for (var new_folder of new_folders) {
                    let new_folder_path = new_folder["requested_path"]
                    let new_folder_id = new_folder["id"]
                    folder_paths[new_folder_path] = new_folder_id

                    // Add to the namespace
                    this.init_folder(new_folder)
                    this.namespace.push(new_folder)
                }

                // Step into the first folder
                if(new_folders.length > 0){
                    this.change_folder_to(new_folders[0])
                }

                // Uploads the files from all the folders, to the correct paths.
                files
                    .filter(f => f.name && f.size > 0)
                    .forEach(userfile => {

                        var self = this

                        // Look for the parent path with '_' instead of ':' (relevant only when the folder name had a '/' in it, macOS only)
                        const path = userfile.webkitRelativePath.replace(/:/g, '_')
                        const parent_path = path.substring(0, path.lastIndexOf("/"))
                        const parent_id = folder_paths[parent_path]

                        //if folder_paths[parent_path] is undefined skip file, log error
                        if(parent_id === undefined) {
                            Utils.show_error("File '"+userfile.name+"' has no path!")
                            console.error("File '"+userfile.name+"': parent_id was undefined", userfile, folder_paths)
                            return
                        }

                        // Construct the file list item manually
                        const temp_file_id =  (++this.uploading_files_ctr) * -1
                        let file_record = {
                            id: temp_file_id,
                            entity_type: NamespaceService.ENTITY_TYPE_FILE,
                            name: userfile.name,
                            size: userfile.size,
                            parent_id: parent_id,
                            loading: true,
                            last_modified_by: self.user.id,
                            versions_num: 0,
                            shares_num: 0
                        }

                        // Add the files to the namespace
                        this.init_file(file_record)
                        this.namespace.push(file_record)

                        this.upload_queue.push({
                            file: file_record,
                            userfile: userfile,
                            is_uploading: false
                        })
                    })
                Utils.show_success("Folder"+(folder_paths.length > 1 ? 's' : '')+" created successfully, starting file upload...")
                this.folder_upload_el.value=""
            }).catch(err_resp => {
                Utils.show_error("Error creating folders: " + err_resp.body.message)
                console.error(err_resp)
            })
        },

        async upload_file(file, userfile){
            // Start uploading a file from the upload queue 
            if(this.disable_upload){ return }

            // Upload using the new FileUploader
            const redundant_packets = this.user.team_settings && this.user.team_settings.config ?  this.user.team_settings.config.cloud_selector_redundant_packets : 1
            const config = {
                redundant_num: redundant_packets,
                encrypt_data: true
            }
            this.$set(file, 'cancel', {})
            
            try{
                const uploaded_version = await (new FileUploader()).uploadFile(file, userfile, config)
                Utils.show_success(`<b>${file.name}</b> uploaded.`)

                // Upload cannot be cancelled any more
                if('cancel' in file) delete file.cancel

                file.loading = false
                file.size = uploaded_version.size
                file.last_modified_by = uploaded_version.user_id
                file.last_modified = uploaded_version.timestamp
                // TODO the new number of versions depends on the 'versions_to_kept'
                // setting of the Team Config! It should be provided by the backend and set here
                file.versions_num++
                
                // Notify parent of a new file upload
                this.$emit('file_uploaded', file)
                
                // Reload used storage (via App.js)
                bus.$emit(events.USED_STORAGE_CHANGED)

                this.cache_namespace()

                // Remove from upload queue
                const queue_index = this.upload_queue.findIndex(item => item.file.id == file.id)
                if(queue_index >= 0){
                    // File found in the current upload queue, remove
                    this.upload_queue.splice(queue_index, 1)
                }
                else{
                    console.warn("File that finished uploading was not found in upload queue!", file, this.upload_queue.map(q => q.file.id))
                }

            } catch(err) {
                // Upload failed (error or user cancelled)

                file.loading = false
                if('cancel' in file) delete file.cancel

                // If would have been a new file, remove from cached namespace (and file list)
                if(file.id < 0){
                    const idx = this.namespace.findIndex(f => f.id == file.id )
                    if(idx >= 0){ 
                        this.namespace.splice(idx, 1) 
                        this.cache_namespace()
                    }
                }

                // Remove from upload queue
                const queue_index = this.upload_queue.findIndex(item => item.file.id == file.id)
                if(queue_index >= 0){
                    // File found in the current upload queue, remove
                    this.upload_queue.splice(queue_index, 1)
                }

                if(!(err && err.cancelled)){
                    // It was an error, not cancelled
                    console.error("Error uploading file: ", err)
                    let error_msg = "Error uploading <b>"+file.name+"</b>. "
                    if(err && err.body && err.body.message){
                        error_msg += err.body.message
                    }
                    else{
                        error_msg += "Please try again later!"
                    }
                    Utils.show_error(error_msg)
                }
            }

                
        },

        open_file(file) {
            if(this.disable_download){ return }
            const previewable_files = this.files.filter(f => f.viewer) 
            bus.$emit(events.OPEN_FILE_VIEWER, { file, previewable_files })
        },

        download_file(file, version_id){
            if(this.disable_download){ return }

            // On mobile we'll open the file
            // TODO: use the gateway on mobile, don't attempt to reconstruct it locally!
            this.$set(file, 'open_when_ready', this.is_mobile ? true : false)
            this._do_download_file(file, version_id)
        },

        download_all_selected(){
            if(this.disable_download || !this.selected_files.length) return 

            // Push all selected files to download queue
            this.files_multidownload_in_progress = true
            this.selected_files.forEach(file => {
                //file.loading = true
                this.download_queue.push({
                    file: file,
                    is_downloading: false
                })
            })
        },

        download_all_cancel(){
            // Clear download queue and cancel any files currently downloading
            this.download_queue.splice(-1)
            this.files.filter(f => f.cancel).forEach(f => { f.cancel() })
            this.files_multidownload_in_progress = false
        },

        _do_download_file(file, version_id){
            if(this.disable_download){ return }

            this.$set(file, 'cancel', {})
            this.$set(file, 'is_mobile_download', this.is_mobile)
            Utils.download_or_open_file(
                file, 
                version_id, 

                (downloaded_file) => {
                    // View ready
                    this.$emit('file_download_succeeded', file)
                    if(this.is_mobile){
                        // Try to open or download the file on mobile
                        Utils.force_download_file(file, downloaded_file.download_url, null, true, true)
                    }
                }, 
                
                (file) => {
                    // File downloaded

                    if('cancel' in file){
                        delete file.cancel
                        this.cache_namespace()
                    }

                    this.$emit('file_download_succeeded', file)
                    
                    // Unselect (if download is from multiselect)
                    file.selected = false
                    
                    // Download ready, remove from queue if it came from there
                    const queue_index = this.download_queue.findIndex(item => { return item.file.id == file.id })
                    if(queue_index >= 0){
                        // File found in the current upload queue, remove
                        this.download_queue.splice(queue_index, 1)
                    }
                    
                }, () => {
                    // Download cancelled
                    this.cache_namespace()

                })
        },

        new_folder_form(is_open){
            if(this.disable_namespace_ops){ return }

            if(is_open){
                this.new_folder_mode = true
                this.new_folder_name = ""
                this.$nextTick(()=> {
                    document.getElementById("new_folder_name_input").focus()
                })
            }

            else{
                this.new_folder_mode = false
                this.new_folder_name = ""
            }
        },

        create_folder(folder_name){
            if(this.disable_namespace_ops){ return }
            if(this.new_folder_loading){ return }
            this.new_folder_loading = true
            NamespaceService.create_folder(folder_name, this.current_dir.id).then(res => {
                // Hide form
                this.new_folder_form(false)
                let new_folder = res.body
                this.init_folder(new_folder)
                // Add to namespace if its not there already (might have been received by a sync update in the meantime)
                if(!this.namespace.find(entity => entity.id == new_folder.id)){
                    this.namespace.push(new_folder)
                    this.cache_namespace()
                }

                Utils.show_success(`Folder '${new_folder.name}' created.`)
            }).catch(err_resp => {
                console.error("Error creating folder", err_resp)
                Utils.show_error(`Error creating folder '${folder_name}'${err_resp.body?.message || 'Interal Error'}`)
            }).finally(() => {this.new_folder_loading = false})
        },

        open_share_form(entities){
            /**
             * Opens the New Share dialog box with the given entities to be shared
             * 
             * @param entities A single File/Folder or an array of files to share.
             *  Sharing multiple folders and mixing files+folders is not supported.
             */
            if(this.disable_share){ return }
            if(!Array.isArray(entities)){ entities = [ entities ] }

            bus.$emit(events.CREATE_SHARE, entities)
        },

        onNewShare(shared_entity_ids){
            // Event handler from the Share Form when file(s) or a folder have been shared.
            // Increase shares_num for each shared entity
            shared_entity_ids.forEach(entity_id => {
                const entity = this.namespace.find(e => e.id == entity_id)
                if(!entity) return

                if(!('shares_num' in entity)) this.$set(entity, 'shares_num', 0)
                entity.shares_num++
            })

            // If files were shared from a multi-select, de-select everything
            if(shared_entity_ids.length > 1){
                this.multiselect_clear()
            }
        },

        open_file_info_modal(file, view='info'){
            bus.$emit(events.OPEN_INFO_MODAL, {file, view})
        }

    },
}
</script>

<style lang="css" scoped>

    .folder-box{ cursor: pointer; transition: all .3s ease; }
    .folder-box:hover .cardbox{ box-shadow: 0px 3px 16px 0px rgba(123, 123, 123, 0.35) }
    .folder-box .cardbox .cardbox-body{ padding: 8px 16px }
    .folder-box.add_folder .cardbox-body{ padding-right: 16px; /* Set the padding back in the new folder box */ }
    .folder-box .foldername{ white-space: nowrap; overflow: hidden; text-overflow: ellipsis }
    /* In Dark mode folder names and rename input box should be white */
    .theme-dark .foldername,
    .theme-ironshard .foldername,
    .theme-dark .folder-box input,
    .theme-ironshard .folder-box input
    {
        color: white !important
    }
    .folder-box.dragover{
        opacity: .6;
    }

    .folder-box.dragover .cardbox{
        background: #03A9F4;
        color: white;
        font-weight: bold
    }
    /*.folder-box.dragover .cardbox.color-indigo-400{ background: #5c6bc0 }*/

    .breadcrumb .icon{
        font-size: 16pt
    }

    .icon{
        font-size: 14pt;
        line-height: 1;
    }

    button.btn, a.btn{
        cursor: pointer;
    }

    tr.highlighted td{
        background: #1E88E5;
        color: white
    }

    tbody.open{
        /* When file info is open, the file row gets a shadow */
        box-shadow: 0 0 30px 0 #BABABA;
    }
    tbody.open tr:hover td{
        /* Disable hover highlight for open files (since they consist of 2 rows, it looks weird) */
        background: white
    }
    .theme-dark tbody.open tr:hover td,
    .theme-ironshard tbody.open tr:hover td{
        background: transparent
    }

    .cardbox-body.folder-details{
        cursor: default
    }

    .file_download_link:hover{
        text-decoration: underline;
        cursor: pointer;
    }
   
    .file-list thead th{
        font-size: 12pt;
        text-transform: uppercase;
        border: 0px
    }

    .file-list .filename{
        white-space: pre-wrap; /* css-3 */
        white-space: -moz-pre-wrap; /* Mozilla, since 1999 */
        white-space: -pre-wrap; /* Opera 4-6 */
        white-space: -o-pre-wrap; /* Opera 7 */
        word-break: break-all;
        word-wrap: break-word;
        overflow-wrap:break-word;
        display: flex
     }

    .file-list th,
    .file-list tr.file-row td{ text-align: center } /* File list table cells: set default text align to center */
    .file-list thead .sort_header{ cursor: pointer; } /* Sortable headers pointer cursor */

    .file-row tbody{ border: 0px }

    
    tr.file-loading,
    tr.file-loading td { padding: 0px; margin: 0px; border: 0px }
    tr.file-loading td .progress{ padding: 0px; height: 3px }
    tr.file-loading td .progress-bar { height: 3px; margin: 0px }


    .modal-dialog{
        box-shadow: 0;
    }


    .dropdown-item i{ /* Align the labels nicely */ width: 2em }
    .filter-modal .modal-dialog{
        box-shadow: 0 0 30px 0 #BABABA;
    }

    .filters span i{ opacity: .75; cursor: pointer; }
    .filters span i:hover{ opacity: 1;  }

    #dropzone{
        background: #eceff1;
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        z-index: 999;
        opacity: 0.6;
        visibility: hidden;
        text-align: center;
        color: black;
        font-weight: bold;
        font-size: 5em;
        padding-top: calc(50% - 4em);
    }
    .drag_valid #dropzone{
        visibility: visible;
    }

    /*
    #dropzone{
        display: none
        }
        .drag_valid #dropzone{
            display: flex;
            height: 100%;
            width: 100%;
            padding-top: 15em
            }
        */

    #folders .ion-folder,
    #folders .ion-plus{
        font-size: 25px
    }
    #breadcrumb .ion-folder{
        font-size: 20px
    }
    .folder-overflow-btn{
        border: none
    }

    .file-version-label{
        border: 1px solid #ebebeb;
        border-radius: 3px;
        padding: .5em
    }

    @media (max-width: 992px) {

        .breadcrumb{
            padding: 10px;
            margin-bottom: 1em;
        }

        .breadcrumb .btn{
            font-size: 1em
        }

        #folders .ion-folder,
        #folders .ion-plus,
        #breadcrumb .ion-folder{
            /* Remove extra vertical spacing in the folder boxes */
            line-height: 0px;
        }

        /* Make file rows thinner */

        table tr.file-row td{
            padding: .5em
        }

        /* Less padding between the action buttons and edge */
        #files .cardbox-heading{
            padding: 8px
        }
        /* Smaller action buttons in file list header */
        #files .action-buttons button.btn{
            padding: .4em .9em;
            font-size: .9em;
        }
    }
</style>